export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';

export const DELETE_USERS_REQUEST = 'DELETE_USERS_REQUEST';
export const DELETE_USERS_SUCCESS = 'DELETE_USERS_SUCCESS';
export const DELETE_USERS_FAILED = 'DELETE_USERS_FAILED';

export const RESEND_INVITE_REQUEST = 'RESEND_INVITE_REQUEST';
export const RESEND_INVITE_SUCCESS = 'RESEND_INVITE_SUCCESS';
export const RESEND_INVITE_FAILED = 'RESEND_INVITE_FAILED';

export const ASSIGN_LABELS_REQUEST = 'ASSIGN_LABELS_REQUEST';
export const ASSIGN_LABELS_SUCCESS = 'ASSIGN_LABELS_SUCCESS';
export const ASSIGN_LABELS_FAILED = 'ASSIGN_LABELS_FAILED';

export const ADD_USER_WITH_CSV_REQUEST = 'ADD_USER_WITH_CSV_REQUEST';
export const ADD_USER_WITH_CSV_SUCCESS = 'ADD_USER_WITH_CSV_SUCCESS';
export const ADD_USER_WITH_CSV_FAILED = 'ADD_USER_WITH_CSV_FAILED';

export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const TOGGLE_ALL_ROWS = 'TOGGLE_ALL_ROWS';
